import React, { Component } from 'react';
import { connect } from 'react-redux';
import Sticky from 'Components/Sticky';
import ResponsiveTable from 'Components/ResponsiveTable';
import Heading from 'Components/Heading';
import { GET_PR_TRACKING_DETAILS } from 'Constants/actionConstants';
import { getUser } from 'Utils/storage';
import Moment from 'moment';

class PRTracking extends Component {
    constructor() {
        super();
    }

    componentDidMount() {
        this.getPRTracking();
    }

    getPRTracking = () => {
        const { dispatch } = this.props;
        dispatch({
            type: GET_PR_TRACKING_DETAILS,
            param: {
                companyId: getUser().companyId
            }
        })
    }

    render() {
        const { tracking } = this.props;

        return (
            <Sticky>
                <div className="mt-10 ml-10 mr-10">
                    <Heading className="tCenter" text="PR Tracking" />
                    <ResponsiveTable className="pr-table pr-tracking pv-10 ph-10">
                        <table cellpadding="0" cellspacing="0" className="col-1">
                            <thead>
                                <tr>
                                    <th>PR No</th>
                                    <th>PR Date</th>
                                    <th>Item</th>
                                    <th>UOM</th>
                                    <th>Quantity</th>
                                    <th>Store Location</th>
                                    <th>TL/SS</th>
                                    <th>Activity</th>
                                    <th>Approval Note No-AN-No</th>
                                    <th>Approved Amount</th>
                                    <th>Proposed Vendor Name</th>
                                    <th>PO Number</th>
                                    <th>PO Value</th>
                                    <th>Supply Done</th>
                                    <th>REL-1</th>
                                    <th>REL-2</th>
                                    <th>Check</th>
                                    <th>STR GRN</th>
                                    <th>SAP GRN</th>
                                    <th>Given To PHANI</th>
                                </tr>
                            </thead>
                            <tbody>
                                {tracking.map(val => 
                                (<tr>
                                    <td>{`${val.requisition_number} / ${val.pr_date && Moment(val.pr_date).format('DD.MM.YYYY') || ''}`}</td>
                                    <td>{val.pr_date && Moment(val.pr_date).format('DD MMM YYYY') || ''}</td>
                                    <td>{val.from && `${val.from} - ${val.to}` || '-'}</td>
                                    <td>{val.pricing_basis_name || '-'}</td>
                                    <td>{val.total_estimated_qty || '-'}</td>
                                    <td>{'-'}</td>
                                    <td>{'-'}</td>
                                    <td>{val.activity || '-'}</td>
                                    <td>{val.approval_note_number || '-'}</td>
                                    <td>{val.approved_budget || '-'}</td>
                                    <td>{val.transporter_name || '-'}</td>
                                    <td>{`${val.requisition_number} / ${val.pr_date && Moment(val.pr_date).format('DD.MM.YYYY') || ''}`}</td>
                                    <td>{val.price || '-'}</td>
                                    <td>{'-'}</td>
                                    <td>{'-'}</td>
                                    <td>{'-'}</td>
                                    <td>{'-'}</td>
                                    <td>{'-'}</td>
                                    <td>{'-'}</td>
                                    <td>{'-'}</td>
                                </tr>))}
                            </tbody>
                        </table>
                    </ResponsiveTable>
                </div>
            </Sticky>
        )
    }
}

const mapStateToProps = ({ contracting }) => {
    return {
        tracking: contracting.prTackingData || [],
        loading: contracting.loader
    }
};

export default connect(mapStateToProps)(PRTracking);